import React, { Component } from 'react';
import classNames from 'classnames';
import FileStackImage from 'misc/filestack_image';
import { Spinner } from 'ui';
import DropTarget from './DropTarget';

// This component is used to display file stack images, this will refactor to remove all the unnecessary code
// when we remove all the file stack functionality
class ViewFinder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      image: FileStackImage.url(props.image),
    };
    this.handleImageLoad = this.handleImageLoad.bind(this);
  }

  static LoadingSpinner = () => (
    <div>
      <Spinner color="darker" />
      <span className="ml-16 c-gray">{t('common.loading')}</span>
    </div>
  );

  componentDidUpdate(prevProps) {
    if (this.props.uploading !== prevProps.uploading) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ loading: true });
    }
    if (this.props.image.handle !== prevProps.image.handle) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ image: FileStackImage.url(this.props.image) });
    }
  }

  handleImageLoad() {
    this.setState({ loading: false });
  }

  render() {
    const { loading } = this.state;
    const { onUpload, caption, uploading, id, bssUploadEnabled } = this.props;
    const imageContainerClassName = classNames({
      'Animated Animated--fadeIn': !loading,
      'clickable-image-upload': !loading,
      hidden: loading,
    });
    // will be replaced with a direct feature flag check when all elements are migrated to UUC
    if (bssUploadEnabled) {
      return (
        <div>
          {loading && <ViewFinder.LoadingSpinner />}
          <img
            alt={caption}
            src={this.state.image}
            onLoad={this.handleImageLoad}
          />
        </div>
      );
    }

    return (
      <div>
        {loading && <ViewFinder.LoadingSpinner />}
        {this.props.connectDropTarget(
          <div className={imageContainerClassName}>
            <label className="m-0 c-p" htmlFor={`${id}_image`}>
              <img
                alt={caption}
                src={this.state.image}
                onLoad={this.handleImageLoad}
              />
            </label>
            <input
              hidden
              id={`${id}_image`}
              type="file"
              accept="image/*"
              onChange={e => onUpload(e.target.files[0])}
              disabled={uploading || loading}
            />
          </div>,
        )}
      </div>
    );
  }
}

export default DropTarget(ViewFinder);
